// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  padding: var(--space-6);
  display: block;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  background-color: var(--color-surface-muted);
}
:host .content-row {
  display: flex;
  flex-direction: row;
  gap: var(--space-5);
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
:host .content-row .content-box {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  flex: 1;
  min-width: 0;
}
:host .content-row .content-box.large {
  flex: 1.6;
}
:host .content-row .content-box .card {
  background-color: var(--color-surface);
  display: flex;
  flex: 1;
  flex-direction: column;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}
:host .content-row .content-box .card.space {
  margin-top: 0;
}
:host .content-row .content-box .card__title {
  padding: var(--space-5) var(--space-5) var(--space-3);
  font-weight: 700;
  font-size: 16px;
  color: var(--color-text);
  letter-spacing: -0.01em;
  border-bottom: 1px solid var(--color-border);
}
:host .content-row .content-box .card__content {
  padding: var(--space-3) var(--space-5);
  flex: 1;
  overflow: auto;
}
:host .content-row .content-box .card__content.nopadding {
  padding: 0;
}
:host .content-row .content-box .card__footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--space-3) var(--space-5);
  text-transform: uppercase;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.06em;
  color: var(--color-text-muted);
  border-top: 1px solid var(--color-border);
  -webkit-user-select: none;
          user-select: none;
  transition: color 120ms ease, background-color 120ms ease;
}
:host .content-row .content-box .card__footer:hover {
  color: var(--color-brand);
  background-color: var(--color-brand-soft);
  cursor: pointer;
}

.table-row {
  padding: var(--space-3) 0;
  border-bottom: 1px solid var(--color-border);
}
.table-row:last-child {
  border-bottom: none;
}
.table-row__title {
  display: flex;
  align-items: center;
  margin-bottom: var(--space-1);
}
.table-row__title span {
  font-weight: 600;
  font-size: 14px;
  color: var(--color-brand);
}
.table-row__content {
  font-size: 13px;
  color: var(--color-text-muted);
  line-height: 1.5;
}

.order-row {
  padding: var(--space-3) var(--space-5);
  display: grid;
  grid-template-columns: minmax(0, 1fr) 140px 100px 180px;
  align-items: center;
  gap: var(--space-3);
  border-bottom: 1px solid var(--color-border);
  font-size: 14px;
  color: var(--color-text);
  transition: background-color 120ms ease;
}
.order-row--tender {
  grid-template-columns: 60px minmax(0, 1fr) 110px 200px;
}
.order-row:last-child {
  border-bottom: none;
}
.order-row:hover {
  background-color: var(--color-brand-soft);
}
.order-row:hover .reee {
  color: var(--color-brand);
  text-decoration: underline;
}
.order-row:hover mat-icon {
  color: var(--color-brand);
}
.order-row:hover .redoOrder {
  color: var(--color-brand);
}
.order-row__primary {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
}
.order-row__date {
  color: var(--color-text);
  font-weight: 600;
}
.order-row__sep {
  color: var(--color-border-strong);
}
.order-row__id {
  color: var(--color-text-muted);
  font-variant-numeric: tabular-nums;
}
.order-row__company {
  color: var(--color-text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.order-row__count {
  color: var(--color-text-muted);
  font-size: 13px;
  text-align: center;
}
.order-row__action {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--space-2);
}
.order-row__action-link {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  cursor: pointer;
  color: var(--color-text-muted);
  transition: color 120ms ease;
}
.order-row__action-link:hover {
  color: var(--color-brand);
}
.order-row__action-link mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.order-row .reee {
  cursor: pointer;
  color: var(--color-text-muted);
  transition: color 120ms ease;
}

.redoOrder {
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-muted);
  cursor: pointer;
  outline: none;
  transition: color 120ms ease;
}
.redoOrder:hover {
  color: var(--color-brand);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/component/pages/dashboard/dashboard.component.sass"],"names":[],"mappings":"AAAC;EACC,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,4CAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AACJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;EACA,YAAA;AACN;AACM;EACE,SAAA;AACR;AACM;EACE,sCAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,qCAAA;EACA,+BAAA;EACA,4BAAA;EACA,gBAAA;AACR;AACQ;EACE,aAAA;AACV;AACQ;EACE,qDAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,uBAAA;EACA,4CAAA;AACV;AACQ;EACE,sCAAA;EACA,OAAA;EACA,cAAA;AACV;AACU;EACE,UAAA;AACZ;AACQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,8BAAA;EACA,yCAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yDAAA;AACV;AACU;EACE,yBAAA;EACA,yCAAA;EACA,eAAA;AACZ;;AAGA;EACE,yBAAA;EACA,4CAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAAJ;AAEI;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;AAAN;AAEE;EACE,eAAA;EACA,8BAAA;EACA,gBAAA;AAAJ;;AAGA;EACE,sCAAA;EACA,aAAA;EACA,uDAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EACA,eAAA;EACA,wBAAA;EACA,uCAAA;AAAF;AAEE;EACE,sDAAA;AAAJ;AAEE;EACE,mBAAA;AAAJ;AAEE;EACE,yCAAA;AAAJ;AAEI;EACE,yBAAA;EACA,0BAAA;AAAN;AAEI;EACE,yBAAA;AAAN;AAEI;EACE,yBAAA;AAAN;AAEE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAAJ;AAEE;EACE,wBAAA;EACA,gBAAA;AAAJ;AAEE;EACE,iCAAA;AAAJ;AAEE;EACE,8BAAA;EACA,kCAAA;AAAJ;AAEE;EACE,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AAEE;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;AAAJ;AAEE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,4BAAA;AAAJ;AAEI;EACE,yBAAA;AAAN;AAEI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAAN;AAEE;EACE,eAAA;EACA,8BAAA;EACA,4BAAA;AAAJ;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,4BAAA;AACF;AACE;EACE,yBAAA;AACJ","sourcesContent":["\\:host\n  padding: var(--space-6)\n  display: block\n  width: 100%\n  height: 100%\n  box-sizing: border-box\n  overflow: auto\n  background-color: var(--color-surface-muted)\n\n  .content-row\n    display: flex\n    flex-direction: row\n    gap: var(--space-5)\n    height: 100%\n    max-width: 1200px\n    margin: 0 auto\n\n    .content-box\n      display: flex\n      flex-direction: column\n      gap: var(--space-5)\n      flex: 1\n      min-width: 0\n\n      &.large\n        flex: 1.6\n\n      .card\n        background-color: var(--color-surface)\n        display: flex\n        flex: 1\n        flex-direction: column\n        border: 1px solid var(--color-border)\n        border-radius: var(--radius-lg)\n        box-shadow: var(--shadow-sm)\n        overflow: hidden\n\n        &.space\n          margin-top: 0  // gap on parent handles spacing\n\n        &__title\n          padding: var(--space-5) var(--space-5) var(--space-3)\n          font-weight: 700\n          font-size: 16px\n          color: var(--color-text)\n          letter-spacing: -0.01em\n          border-bottom: 1px solid var(--color-border)\n\n        &__content\n          padding: var(--space-3) var(--space-5)\n          flex: 1\n          overflow: auto\n\n          &.nopadding\n            padding: 0\n\n        &__footer\n          display: flex\n          justify-content: center\n          align-items: center\n          padding: var(--space-3) var(--space-5)\n          text-transform: uppercase\n          font-weight: 600\n          font-size: 12px\n          letter-spacing: 0.06em\n          color: var(--color-text-muted)\n          border-top: 1px solid var(--color-border)\n          user-select: none\n          transition: color 120ms ease, background-color 120ms ease\n\n          &:hover\n            color: var(--color-brand)\n            background-color: var(--color-brand-soft)\n            cursor: pointer\n\n\n// Notifications panel (\"Meldingen\") rows\n.table-row\n  padding: var(--space-3) 0\n  border-bottom: 1px solid var(--color-border)\n\n  &:last-child\n    border-bottom: none\n\n  &__title\n    display: flex\n    align-items: center\n    margin-bottom: var(--space-1)\n\n    span\n      font-weight: 600\n      font-size: 14px\n      color: var(--color-brand)\n\n  &__content\n    font-size: 13px\n    color: var(--color-text-muted)\n    line-height: 1.5\n\n// Order / tender list rows in the Laatste bestellingen / Offertes cards\n.order-row\n  padding: var(--space-3) var(--space-5)\n  display: grid\n  grid-template-columns: minmax(0, 1fr) 140px 100px 180px\n  align-items: center\n  gap: var(--space-3)\n  border-bottom: 1px solid var(--color-border)\n  font-size: 14px\n  color: var(--color-text)\n  transition: background-color 120ms ease\n\n  &--tender\n    grid-template-columns: 60px minmax(0, 1fr) 110px 200px\n\n  &:last-child\n    border-bottom: none\n\n  &:hover\n    background-color: var(--color-brand-soft)\n\n    .reee\n      color: var(--color-brand)\n      text-decoration: underline\n\n    mat-icon\n      color: var(--color-brand)\n\n    .redoOrder\n      color: var(--color-brand)\n\n  &__primary\n    display: flex\n    align-items: center\n    gap: var(--space-2)\n    min-width: 0\n\n  &__date\n    color: var(--color-text)\n    font-weight: 600\n\n  &__sep\n    color: var(--color-border-strong)\n\n  &__id\n    color: var(--color-text-muted)\n    font-variant-numeric: tabular-nums\n\n  &__company\n    color: var(--color-text-muted)\n    overflow: hidden\n    text-overflow: ellipsis\n    white-space: nowrap\n\n  &__count\n    color: var(--color-text-muted)\n    font-size: 13px\n    text-align: center\n\n  &__action\n    display: flex\n    justify-content: flex-end\n    align-items: center\n    gap: var(--space-2)\n\n  &__action-link\n    display: inline-flex\n    align-items: center\n    gap: var(--space-1)\n    cursor: pointer\n    color: var(--color-text-muted)\n    transition: color 120ms ease\n\n    &:hover\n      color: var(--color-brand)\n\n    mat-icon\n      font-size: 18px\n      width: 18px\n      height: 18px\n\n  .reee\n    cursor: pointer\n    color: var(--color-text-muted)\n    transition: color 120ms ease\n\n.redoOrder\n  background: none\n  border: none\n  padding: 0\n  font-size: 13px\n  font-weight: 500\n  color: var(--color-text-muted)\n  cursor: pointer\n  outline: none\n  transition: color 120ms ease\n\n  &:hover\n    color: var(--color-brand)\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
